export enum SIGNUP_ROUTES {
  signUpConnectionSuccess = '/signup/connection-success',
  signUpConnectSocials = '/signup/connect-socials',
}

export interface SSORoutes {
  loginSSO: string;
  logoutSSO: string;
}

export interface SignUpRoutes {
  signUpConnectSocials: string;
  signUpConnectionSuccess: string;
}

export interface EchoRoutes {
  echoMessages: string;
  echoPayments: string;
  echoEditProfile: string;
}

export interface SettingsRoutes {
  settingsNotificationsPreferences: string;
  settingsProfile: string;
  settingsAgency: string;
}

export interface AgencyRoutes {
  agencySettings: string;
  agencyTalent: string;
  agencyUsage: string;
}

export interface DemoRoutes {
  contentSearchAutocomplete: string;
}

export interface SwitchRoutes
  extends EchoRoutes,
    SettingsRoutes,
    SignUpRoutes,
    SSORoutes,
    AgencyRoutes,
    DemoRoutes {
  agency: string;
  connectionDashboard: string;
  connectionDashboardEntry: string;
  connectionDashboardLogin: string;
  connectionDashboardSignup: string;
  contentSearch: string;
  watchlist: string;
  creatorBrandDeals: string;
  creatorCampaignReportList: string;
  creatorLiveContent: string;
  creatorLiveContentId: string;
  creatorliveContentIdTikTok: string;
  creatorliveContentIdYouTube: string;
  creatorMediaPackList: string;
  emailAssistant: string;
  emailAssistantResult: string;
  extensionAuthCallback: string;
  extensionAuthCallbackToTutorial: string;
  foamAssistAuthCallback: string;
  foamAssistTutorial: string;
  foamAi: string;
  globalSearch: string;
  logout: string;
  managerRoster: string;
  mediaPackChooseTemplate: string;
  mediaPackDetail: string;
  mediaPacks: string;
  mediaPackSharedView: string;
  myAgency: string;
  myDaily: string;
  myRoster: string;
  notFound: string;
  unauthorized: string;
  platformConnections: string;
  privacyPolicy: string;
  profileOverview: string;
  profileSettings: string;
  reconnectPlatforms: string;
  root: string;
  savedLists: string;
  savedListDetail: string;
  sharedMediaPack: string;
  sharedMediaPackLiveContent: string;
  sharedProfileOverview: string;
  slackAuthCallback: string;
  slackCallback: string;
  talentProfilePlatformConnections: string;
  talentProfileTalentNotes: string;
  talentProfileMediaKits: string;
  termsAndConditions: string;
  onboardingTalentRep: string;
  mediaKits: string;
  mediaKitDetail: string;
  mediaKitSharedPage: string;
  mmvu: string;
}

export type SwitchParams = {
  [name: string]: string | string[];
};

export type SwitchOptionalParams = {
  [name: string]: boolean | string | string[] | undefined;
};
export interface Routes
  extends Omit<
    SwitchRoutes,
    | 'connectionDashboardEntry'
    | 'connectionDashboardLogin'
    | 'connectionDashboardSignup'
    | 'mediaPackDetail'
    | 'creatorLiveContentId'
    | 'creatorliveContentIdTikTok'
    | 'creatorliveContentIdYouTube'
    | 'sharedMediaPack'
    | 'sharedMediaPackLiveContent'
    | 'profileOverview'
    | 'sharedProfileOverview'
    | 'slackCallback'
    | 'slackAuthCallback'
    | 'savedListDetail'
    | 'talentProfilePlatformConnections'
    | 'talentProfileTalentNotes'
  > {
  connectionDashboardEntry: (token: string) => string;
  connectionDashboardLogin: (token: string) => string;
  connectionDashboardSignup: (token: string) => string;
  mediaPackDetail: (id: string, firstTime?: boolean) => string;
  mediaPackShareView: (id: string) => string;
  mediaKitBuilder: (id: string) => string;
  mediaKitShared: (id: string) => string;
  creatorLiveContentId: (contentId: string) => string;
  creatorliveContentIdTikTok: (contentId: string) => string;
  creatorliveContentIdYouTube: (contentId: string) => string;
  profileOverview: (slug: string) => string;
  sharedProfileOverview: (slug: string) => string;
  sharedMediaPack: (sharedToken: string) => string;
  sharedMediaPackLiveContent: (sharedToken: string, sid: string) => string;
  slackCallback: (
    accessToken: string,
    refreshToken: string,
    userId: string,
    state: string,
  ) => string;
  slackAuthCallback: (userId: string, state: string) => string;
  savedListDetail: (id: string, goBackUri?: string) => string;
  contentSearchDetailModal: (id: string) => string;
  talentProfilePlatformConnections: (slug: string) => string;
  talentProfileTalentNotes: (slug: string) => string;
  foamIOCreatorProfile: (slug: string) => string;
}
